import { format, isAfter, isBefore, subYears } from 'date-fns';
import { mapValues } from 'lodash';
import { errors } from '../content/content';
import { SectionWrapperModel } from '../interfaces';

const rawValidators = {
  isPercentage: (p: string, m: SectionWrapperModel) => Number(m[p]) <= 100,
  isRequired: (p: string, m: SectionWrapperModel) => !!m[p],
  isNumber: (p: string, m: SectionWrapperModel) => (m[p] && (!isNaN(Number(m[p])) && Number(m[p]) >= 0)),
  isInteger: (p: string, m: SectionWrapperModel) => (m[p] && (!isNaN(Number(m[p])) && Number(m[p]) % 1 === 0)),
  isMoreThan0: (p: string, m: SectionWrapperModel) => Number(m[p]) > 0,
  isFiftyFiveOrMore: (p: string, m: SectionWrapperModel) => Number(m[p]) >= 55,
  isEighteenOrMore: (p: string, m: SectionWrapperModel) => Number(m[p]) >= 18,
  isEightyOrLess: (p: string, m: SectionWrapperModel) => Number(m[p]) <= 80,
  isOneHundredOrLess: (p: string, m: SectionWrapperModel) => Number(m[p]) <= 100,
  isTenMillionOrLess: (p: string, m: SectionWrapperModel) => Number(m[p]) <= 10000000,
  isOver18: (p: string, m: SectionWrapperModel) => isBefore(format(m[p]), subYears(new Date(), 18)),
  isEqualOrMoreThanCurrentAge: (p: string, m: SectionWrapperModel) => m.age ? Number(m[p]) >= m.age : true,
  isAfter1900: (p: string, m: SectionWrapperModel) => isAfter(format(m[p]), new Date(1899, 11, 31)),
  isInThePast: (p: string, m: SectionWrapperModel) => isBefore(format(m[p]), new Date()),
  isDateValid: (p: string, m: SectionWrapperModel) => {
    if (m[p]) {
      const splitDate = m[p].split('/');
      const day = Number(splitDate[2]);
      const month = Number(splitDate[1]);
      const year = Number(splitDate[0]);
      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (String(year).length !== 4) {
        return false;
      }

      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
      }

      if (month === 0 || month > 12) {
        return false;
      }

      return day > 0 && day <= monthLength[month - 1];
    }

    return false;
  },
};

const buildValidator = (validator: (p: string, m: SectionWrapperModel) => boolean, key: string) =>
  (prop: string, shouldValidate?: (model: SectionWrapperModel) => boolean, error = errors[key]) => [
    (model: SectionWrapperModel) => (shouldValidate && !shouldValidate(model)) || validator(prop, model),
    { [prop]: error },
  ];

const validators = mapValues(rawValidators, buildValidator);

export default validators;



// WEBPACK FOOTER //
// ./src/utilities/validators.ts